import {
  FacilityStatus,
  getFacilityByIdQueryOptions,
} from '@/entities/facility';
import { InfoCard } from '@/shared/components';
import { Tag } from '@/shared/ui';
import { useQuery } from '@tanstack/react-query';
import capitalize from 'lodash.capitalize';
import type { FC } from 'react';

export type InfoCard1Props = {
  facilityId: string;
};

export const InfoCard1: FC<InfoCard1Props> = ({ facilityId }) => {
  const { data: facility, isLoading } = useQuery(
    getFacilityByIdQueryOptions({ facilityId: +facilityId })
  );

  return (
    <InfoCard
      height={116}
      list={[
        {
          id: 'status',
          label: (
            <>
              <Tag
                text={capitalize(facility?.status.toLowerCase())}
                variant={
                  facility?.status === FacilityStatus.ACTIVE ? 'green' : 'red'
                }
              />
            </>
          ),
        },
        {
          id: 'pricingModel',
          label: `Pricing Model – ${facility?.pricingModel?.name ?? 'N/A'}`,
          icon: 'solution',
        },
        {
          id: 'builtYear',
          label: `Built in ${facility?.yearBuilt ?? 'N/A'}`,
          icon: 'calendar',
        },
      ]}
      loading={isLoading}
    />
  );
};
